import React, { useState } from "react";

export default function ButtonMostrarSenha(props) {
  const [tipoInputSenha, setTipoInputSenha] = useState("password");
  const [iconeMostrarSenha, setIconeMostrarSenha] = useState("eye-slash");

  function mostrarSenha() {
    if (tipoInputSenha === "password") {
      setTipoInputSenha("text");
      setIconeMostrarSenha("eye");
    } else {
      setTipoInputSenha("password");
      setIconeMostrarSenha("eye-slash");
    }
  }

  return (
    <div className="input-group">
      <input
        className="form-control"
        type={tipoInputSenha}
        placeholder="Senha"
        name="senha"
        id={"inputSenha-" + props.id}
        defaultValue={props.defaultValue}
        disabled={props.isDisable}
        onChange={props.onChange}
        required
      />
      <div className="input-group-append">
        <button
          className="btn btn-secondary btn-sm"
          type="button"
          onClick={(e) => mostrarSenha(e)}
        >
          <i className={"fa fa-" + iconeMostrarSenha} title="Mostrar senha" />
        </button>
      </div>
    </div>
  );
}
